// Native-side consent persistence mirror.
//
// Problem: in the Capacitor apps the consent record lives in the
// WebView's localStorage, which iOS/Android may evict under memory
// pressure. Losing it would silently re-show the banner AND (worse)
// drop a previously-granted diagnostics consent. @capacitor/preferences
// writes to UserDefaults / SharedPreferences, which are durable.
//
// Two thin helpers, both native-only no-ops on web:
//   mirrorConsentToNative(record)  — fire-and-forget write after every
//                                    decided consent change.
//   readConsentFromNative()        — async read at app launch; the
//                                    caller validates via restoreConsent.
//
// The plugin is imported dynamically so it stays out of the web bundle.

import { isNativeApp } from '../platform';

const PREFS_KEY = 'petzy_cookie_consent';

export async function mirrorConsentToNative(record) {
  if (!isNativeApp || !record) return;
  try {
    const { Preferences } = await import('@capacitor/preferences');
    await Preferences.set({ key: PREFS_KEY, value: JSON.stringify(record) });
  } catch {
    // Non-fatal: localStorage still holds the record for this install;
    // only the eviction-recovery path loses its backup.
  }
}

export async function readConsentFromNative() {
  if (!isNativeApp) return null;
  try {
    const { Preferences } = await import('@capacitor/preferences');
    const { value } = await Preferences.get({ key: PREFS_KEY });
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}
